'use client';
import { productCodesInComparisonAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomValue } from '@effect/atom-react';

/**
 * Custom hook to get the product codes from comparison
 * @returns readonly string[] - Array of product codes in comparison
 */
export function useComparisonProductCodes(): readonly string[] {
  const productCodesResult = useAtomValue(productCodesInComparisonAtom);

  return AsyncResult.match(productCodesResult, {
    onInitial: () => [],
    onFailure: () => [],
    onSuccess: (result) => result.value,
  });
}

/**
 * Custom hook to check if a product code is in the comparison list
 * @param productCode - The product code to check
 * @returns boolean - true if the product is in comparison, false otherwise
 */
export function useIsProductInComparison(productCode: string): boolean {
  const productCodes = useComparisonProductCodes();
  return productCodes.includes(productCode);
}
